var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "step-one fade-in-fwd", attrs: { id: "step-1" } },
    [
      _c(
        "div",
        { staticClass: "body row" },
        _vm._l(Object.entries(_vm.step1CustomData), function(ref) {
          var key = ref[0]
          var el = ref[1]
          return _vm.checkHasRoles(el.roles)
            ? _c("div", { key: el.label, staticClass: "col-sm-6 type-card" }, [
                _c(
                  "div",
                  {
                    staticClass: "type-item",
                    class: { selected: _vm.step1.selectedType === key },
                    attrs: { tabindex: "0", role: "button" },
                    on: {
                      keypress: function() {
                        return _vm.selectItem(el, key)
                      },
                      click: function() {
                        return _vm.selectItem(el, key)
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "type-item__img",
                      class: el.className
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "type-item__label  medium text-size-small font-24"
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$resourceString[el.label]) +
                            "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "type-item__description mb-2 text-size-xsmall gray-bold ",
                        staticStyle: { "font-size": "12px" }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$resourceString[el.description]) +
                            "\n        "
                        )
                      ]
                    )
                  ]
                )
              ])
            : _vm._e()
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }